var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#29DBFF",
    d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#29DBFF",
    d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#29DBFF",
    d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5CC85C",
    d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-82.3 291.431 225.686)",
    fill: "#F7A226",
    cx: 291.4,
    cy: 225.7,
    rx: 48.7,
    ry: 15.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-68.099 303.087 164.67)",
    fill: "#DDC7AB",
    cx: 303.1,
    cy: 164.7,
    rx: 11.7,
    ry: 7.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-81.738 291.697 271.697)",
    fill: "#DDC7AB",
    cx: 291.7,
    cy: 271.7,
    rx: 11.4,
    ry: 3.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
    fill: "#DDC7AB",
    cx: 299.6,
    cy: 269.4,
    rx: 3.3,
    ry: 11
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.518 314.54 201.06)",
    fill: "#DDC7AB",
    cx: 314.5,
    cy: 201.1,
    rx: 4.1,
    ry: 13.7
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.518 317.511 178.077)",
    fill: "#DDC7AB",
    cx: 317.5,
    cy: 178.1,
    rx: 13.7,
    ry: 4.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-7.7 473.781 225.857)",
    fill: "#F7A226",
    cx: 473.6,
    cy: 225.9,
    rx: 15.7,
    ry: 48.7
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.901 462.057 164.866)",
    fill: "#DDC7AB",
    cx: 462,
    cy: 164.9,
    rx: 7.2,
    ry: 11.7
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-8.27 473.27 271.908)",
    fill: "#DDC7AB",
    cx: 473.4,
    cy: 271.9,
    rx: 3.3,
    ry: 11.4
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
    fill: "#DDC7AB",
    cx: 465.5,
    cy: 269.6,
    rx: 11,
    ry: 3.3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-68.482 450.552 201.247)",
    fill: "#DDC7AB",
    cx: 450.6,
    cy: 201.2,
    rx: 13.7,
    ry: 4.1
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-68.482 447.58 178.265)",
    fill: "#DDC7AB",
    cx: 447.6,
    cy: 178.3,
    rx: 4.1,
    ry: 13.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C6CC",
    d: "M373.3 130.3L356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6l-77.8-53.3h22.6l62.5 42.3v11z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.363664b185a36de62fc3143acf44324a.svg";
export { ForwardRef as ReactComponent };